<footer class="pt-4 pb-4 text-muted text-center d-print-none">
    <div class="container">
        <div class="my-3">
            <div class="h4">Anas CHARFI</div>
            <div class="footer-nav">
                <nav role="navigation">
                    <ul class="nav justify-content-center">

                        <li class="nav-item"><a class="nav-link" href="https://twitter.com/CharfiAnas"
                                title="Twitter"><i class="fab fa-twitter"></i><span
                                    class="menu-title sr-only">Twitter</span></a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.facebook.com/The.Hakerz.Zinger/"
                                title="Facebook"><i class="fab fa-facebook-f"></i><span
                                    class="menu-title sr-only">Facebook</span></a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="https://www.instagram.com/anascharfi/"
                                title="Instagram"><i class="fab fa-instagram"></i><span
                                    class="menu-title sr-only">Instagram</span></a></li>
                        <li class="nav-item"><a class="nav-link" href="https://www.linkedin.com/in/anas-charfi/"
                                title="LinkedIn"><i class="fab fa-linkedin"></i><span
                                    class="menu-title sr-only">LinkedIn</span></a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="https://github.com/AnasCharfi" title="Github"><i
                                    class="fab fa-github"></i><span class="menu-title sr-only">Github</span></a></li>

                    </ul>
                </nav>
            </div>
        </div>
        <div class="text-small">
            <div class="mb-1">&copy; My Resume. All rights reserved.</div>
            <div> <a target="_blank">Have a nice LIFE!</a></div>
        </div>
    </div>
</footer>


<div id="scrolltop" style="position:relative; z-index: 999;"><a class="btn btn-primary smooth-scroll" href="#top"><span
            class="icon"><i class="fas fa-angle-up fa-2x"></i></span></a></div>
<script src="/assets/2nd/scripts/bootstrap.bundle.min.js?ver=1.2.0"></script>
<script src="/assets/2nd/scripts/aos.js?ver=1.2.0"></script>
<script src="/assets/2nd/scripts/main.js?ver=1.2.0"></script>
<script src="/assets/scripts/imagesloaded.pkgd.min.js?ver=1.1.0"></script>
<script src="/assets/scripts/masonry.pkgd.min.js?ver=1.1.0"></script>
<script src="/assets/scripts/bootstrap.bundle.min.js?ver=1.1.0"></script>
<script src="/assets/scripts/aos.js?ver=1.1.0"></script>
<script src="/assets/scripts/main.js?ver=1.1.0"></script>